import classNames from 'classnames';
import React, { ComponentProps } from 'react';
import { Typography, TypographyVariant } from '../typography/typography';
import { SeriesNumber } from '../series-number/series-number';
import styles from './product-line.module.scss';

const DEFAULT_SERIES_COLOR = '#66b1e3';

type Props = {
  series: React.ReactNode;
  seriesNumber: string;
  seriesNumberColor?: string;
  variant?: Extract<ComponentProps<typeof SeriesNumber>['variant'], 'small' | 'big'>;
};

export const ProductLine: React.FC<Props> = ({
  series,
  seriesNumber,
  seriesNumberColor = DEFAULT_SERIES_COLOR,
  variant = 'small',
}) => {
  const fontVariant: TypographyVariant = variant === 'big' ? 'headline-3' : 'smalltext';
  const isBoldStyle = fontVariant === 'smalltext';

  return (
    <span className={classNames(styles.root, styles[variant])}>
      <span className={styles.textContainer}>
        <Typography fontStyle={isBoldStyle ? 'bold' : undefined} tag="span" variant={fontVariant}>
          {series}
        </Typography>
      </span>
      <SeriesNumber seriesNumber={seriesNumber} seriesNumberColor={seriesNumberColor} variant={variant} />
    </span>
  );
};
